import { render, staticRenderFns } from "./instaPoster.vue?vue&type=template&id=53b97bfa&"
import script from "./instaPoster.vue?vue&type=script&lang=js&"
export * from "./instaPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports